const en = {
  "1 day": "1 Day",
  "1 month": "1 Month",
  "6 weeks": "6 Weeks",
  "7 day": "7 Day",
  "9w-deposit": "Exchange Deposit",
  "9w-withdraw": "Exchange Withdrawal",
  added: "Added",
  about: "About",
  "about-us": "About Us",
  aboutus_page: "About Us",
  account: "Account",
  account_number1: "Account Number",
  accountname: "Account Name",
  active_bonus_tab: "Active",
  add_another_address: "Add Another Address",
  add_bank: "Add Bank",
  add_bank_account: "Add Bank Account",
  add_wallet_aadress: "please enter wallet address",
  add_wallet_address: "Add Wallet Address",
  address: "Address",
  "adhaar card": "Adhaar Card",
  "adjustment by admin": "Adjustment by Admin",
  affiliates: "Affiliates",
  affiliates_page: "Affiliates",
  age_validation: "Age must be 18+ years",
  all: "All",
  all_provider_games_excluded: "All Provider Games Excluded",
  all_provider_games_included: "All Provider Games Included",
  already_have_an_account: "Already have an account?",
  amount: "Amount",
  amount_after_fee: "amount after fee",
  amount_between: "Amount must be between",
  amount_less_than_balance:
    "The withdrawal request amount is greater than the available balance.",
  amount_less_than_fee_amount: "Amount should be greater than fee amount",
  amount_won: "Amount Won",
  and: "and",
  App: "App",
  app_description:
    "Faster performance, smoother navigation, real-time updates, and access to your favorite games and sports.",
  app_exchange_description: "Trade, bet, and monitor odds instantly.",
  app_exclusive_bonuses: "Exclusive Bonuses",
  app_exclusive_bonuses_description:
    "Unlock special Android-only offers and promotions.",
  app_faster_experience: "Faster Experience",
  app_faster_experience_description:
    "Optimized performance for Android devices.",
  app_install_step1: "Download the APK file",
  app_install_step2: "Enable install from unknown sources",
  app_install_step3: "Open the file and complete installation",
  app_install_steps: "Install in 3 Easy Steps",
  app_instant_notifications: "Instant Notifications",
  app_instant_notifications_description:
    "Get live updates on bets, sports, and promotions.",
  app_pagetitle: "Android App",
  app_scan_to_download: "Scan to download directly on your Android device",
  app_secure_private: "Secure & Private",
  app_secure_private_description:
    "Your account and transactions stay protected.",
  app_sports_description: "Explore live sports betting with instant updates.",
  app_title: "Download the New Sky365 Android App",
  app_why_use_new_android_app: "Why Use the New Android App?",
  app_why_use_new_android_app_description:
    "Built for speed, reliability, and a better mobile experience.",
  applied: "Applied",
  apply: "Apply",
  apply_bonus: "Apply Bonus",
  approved: "Approved",
  awaited: "Awaited",
  back: "Back",
  bad_response_9W_insufficient_withdraw_balance:
    "Not enough funds on the main wallet to request this withdrawal. Please try again later",
  bad_response_amount: "Please enter amount",
  bad_response_bank_required: "Please select bank",
  bad_response_current_password: "Please enter your current password",
  bad_response_document_type: "Please select document type",
  bad_response_expire_date: "Please enter an expiration date",
  bad_response_invalid_email: "Please enter a valid email address",
  bad_response_new_password: "Please enter new password",
  bad_response_select_attachment: "Please select a document.",
  bad_response_select_back_document:
    "Please select the back side of the document.",
  bad_response_select_front_document:
    "Please select the front side of the document.",
  bad_response_valid_age: "Age must be 18 years",
  bad_response_validation_amount: "The amount field must be a number",
  "balance added": "Balance Added",
  "balance adjustment": "Balance Adjustment",
  "balance subtracted": "Balance Subtracted",
  balance_type: "Balance type",
  balanceAdjustment: "Adjustments",
  bank_account_created: "Bank Account Created",
  bank_account_detail: "Account Detail",
  bank_account_id: "Bank Account ID",
  bank_account_length: "Aaccount number must be between 9 to 18 digits",
  bank_account_updated: "Bank Account Updated",
  bank_approved_messsage: "Your bank document has been approved.",
  bank_deletion_success: "Your Bank is Deleted successfully",
  bank_doc_approval: "02. Bank Document Verification",
  bank_name: "Please select the bank name",
  bank_name_label: "Bank Name",
  bank_name1: "Bank Name",
  bank_rejected_message: "Your bank document has been rejected.",
  banking: "Banking",
  beneficiary_name1: "Beneficiary Name",
  bet: "Bet",
  "bet settled": "Bet Settled",
  bet_amount: "Bet Amount",
  betdiscard: "Betdiscard",
  betid: "Bet ID",
  betid_success_copied: "Bet ID Copied Successfully",
  betslipid_success_copied: "Betslip ID Copied Successfully",
  biometrics_updated_successfully: "Biometrics updated successfully",
  BlankNotificationDataError_message:
    "Please enter your email or mobile no to get details.",
  blog: "Blog",
  blog_page: "Blog",
  bonus: "Bonus",
  "bonus credited": "Bonus Credited",
  "bonus reverted": "Bonus Reverted",
  bonus_activated: "Activated",
  bonus_amount: "Bonus Amount",
  bonus_claiming_date: "Claiming Date",
  bonus_crediting_time: "Crediting Time",
  bonus_cycle_cap: "Cycle Cap",
  bonus_end_date: "End Date",
  bonus_name: "Bonus Name",
  bonus_promo_cap: "Promo Cap",
  bonuscanceldate: "Cancelled Date",
  bonusconsumeddate: "Consumed Date",
  bonusdescription: "Description",
  bonusexpireddate: "Expired Date",
  bonusexpiringdate: "Expiring Date",
  both: "Both",
  branch_name1: "Branch Name",
  Call: "Call",
  cancel: "Cancel",
  cancel_btn: "Cancel",
  cancel_deposit_bonus_message:
    "Are you sure you want to cancel deposit bonus?",
  cancel_deposit_bonus_success: "Deposit bonus was cancelled successfully.",
  cancel_ladder_bonus:
    "This bonus is part of a bonus ladder with {0} steps. By confirming the cancellation of the current step, the other {1} steps will also be automatically cancelled.",
  cancelbonus: "Cancel Bonus",
  cancelled_bonus_tab: "Cancelled",
  cashback: "Cashback",
  cashback_days: "Cashback Days",
  cashback_dates: "Cashback Dates",
  cashback_play_time: "Cashback Play Time",
  cashdrop_bonus: "Cashdrop",
  cashout: "Cashout",
  casino: "Casino",
  "casino bet placed": "Casino Bet Placed",
  "casino bet resettled": "Casino Bet Resettled",
  "casino bet settled": "Casino Bet Settled",
  casino_bet: "Casino Bet",
  change: "Change",
  change_btn: "Change",
  change_language: "Change Language",
  change_method: "Change Method",
  change_password: "Change Password",
  change_password_validation_required: "Must be entered",
  change_password_validation_length:
    "Password must be between 6 and 20 characters long",
  change_password_validation_charset:
    "Password can contain numbers (0-9), letters (a-z, A-Z) and special characters (!@#$%^&*) without spaces",
  change_password_validation_not_same_as_current:
    "New password shouldn't be the same as the current password",
  change_password_validation_not_same_as_username:
    "New password shouldn't be the same as username",
  check_deposit_status: "Check your deposit status",
  choose_avatar: "Choose Avatar",
  choose_document_type: "Document Type",
  choose_your_deposit_method: "Choose Deposit Method",
  claim: "Claim",
  claim_until: "Claim until",
  clear: "Clear",
  commission: "Commission",
  confirm_btn: "Confirm",
  confirm_delete: "Confirmation",
  confirm_new_password: "Confirm New Password",
  confirm_password: "Please confirm new password",
  confirm_revert_deposit: "Are you sure you want to revert this deposit?",
  confirm_withdraw:
    "Are you sure you want to proceed with this Withdrawal? By doing so, your active bonus(es) will automatically cancel irreversibly.",
  confirmation_Message_For_Skip_Verification:
    "Please confirm your decision to cancel or perform the action later in your profile section. This message won't be shown again. Are you sure you want to skip the verification process?",
  consumed_bonus_tab: "Consumed",
  Contact_Preferences: "Contact Preferences",
  continue: "Continue",
  create_an_account: "Create An Account",
  crypto_deposit_mobile_verify:
    "To make a Crypto Deposit your mobile number must be verified first.",
  crypto_network: "Crypto Network",
  crypto_withdraw_info1: "You wiill receive",
  crypto_withdraw_info2: "from your ₹",
  crypto_withdraw_info3: "request",
  currentturnover: "Current Turnover",
  daily_deposit_limit: "Daily Deposit Limit",
  daily_deposit_limit_placeholder: "Enter Daily Deposit Limit",
  dailydepositlimitnegativeamountvalidation:
    "Please enter a positive amount of daily deposit limit.",
  dailydepositlimitnotes:
    "Your new daily deposit limit of ₹{0} will become effective in {1}h.",
  dailylimit_biggerthan_monthlyweekly:
    "Daily limit cannot be bigger than weekly/monthly limit.",
  date_of_birth: "Date of Birth",
  declined: "Declined",
  delete_bank_confirmation: "Are you sure you want to delete this bank?",
  deposit: "Deposit",
  "deposit processed": "Deposit Processed",
  deposit_amount_error: "Minimum Deposit to claim this bonus offer is",
  deposit_amount_less_than_hundred:
    "Deposit amount must be greater than hundred.",
  deposit_approved_notification: "Your amount deposit was approved!",
  deposit_btn: "Deposit",
  deposit_limit: "Deposit Limit",
  deposit_method: "in this deposit method.",
  deposit_rejected_notification: "Your amount deposit was not approved!",
  deposit_revert_confirmation_lable:
    "Are you sure you want to revert this deposit request?",
  deposit_reverted_successfully: "Deposit reverted successfully",
  deposit_success_reverted:
    "Your deposit was reverted. You can request a new deposit now.",
  deposit_transaction_update_sent:
    "Deposit transaction update request has been sent.",
  deposit_type: "Deposit Type",
  deposit_under_approval: "Your deposit is under approval!",
  depositlimitsuccessmessage: "Your deposit limit has been set successfully.",
  depositlimitvalidationforblankdata: "Please enter atleast one deposit limit.",
  depositprocessingpara1:
    "You already have pending deposits being processed. A new deposit request will be allowed shortly.",
  details_verification: "Details Verification",
  do_you_want_to_change_password: "Do you want to change password?",
  document_approved_message: "Your identification document has been approved.",
  document_number: "Document Number",
  document_rejected_message: "Your identification document has been rejected.",
  document_upload_successfully: "Documents Inserted successfully.",
  dont_have_an_account: "Don't have an account?",
  download_app: "Download the App",
  "driver license": "Driver License",
  edit: "Edit",
  edit_bank: "Edit Bank",
  email: "Email",
  email_address: "Email Address",
  email_error: "Please enter your email ID",
  email_verified: "Email verified successfully",
  end: "End",
  endbalance: "End Balance",
  enter_additional_concerns: "Enter Additional Concerns",
  enter_amount: "Enter Amount",
  enter_birthdate: "Please enter birthdate",
  enter_confirm_password: "Confirm your new password",
  enter_current_password: "Enter your current password",
  enter_document_number: "Please enter the document number",
  enter_email: "Please enter email",
  enter_full_name: "Enter Full Name",
  enter_mobile: "Please enter mobile number",
  enter_new_password: "Enter your new password",
  enter_reference_number: "Please enter a reference number",
  enter_the_4_digit_code_sent_to_your_email_or_phone:
    "Enter the 4-digit code sent to your email or phone",
  enter_user_name: "Enter User Name",
  enter_valid_amount: "Please enter a valid amount",
  enter_valid_reference_number: "Please enter a valid reference number",
  error: "Error",
  error_account_locked:
    "You have reached maximum number of login attempts so your account is now locked. Contact Customer Support to unlock your account.",
  error_CBWB_cant_claimed_due_to_rewardperiod_ended:
    "The reward period for this bonus has ended, and there is no upcoming crediting cycle. Therefore, claiming or opting in for this bonus is not possible.",
  error_ConfirmPassword: "Please confirm new password",
  error_cooldown_period:
    'Seems like you are having issues logging in. Try again in 3 minutes or click "Forgot Password" and follow the instructions.',
  error_deposit_limit: "Enter atleast one deposit limit",
  error_exceeded_max_attempts:
    "You have exceeded the maximum attempts, please try again after some time.",
  error_Mobile: "Please enter your mobile number",
  error_Password: "Please enter your password",
  error_Username: "Please enter your username",
  error_username_password_invalid: "Username or password is invalid.",
  event_date: "Event Date",
  exchange: "Exchange",
  "exchange bet placed": "Exchange Bet Placed",
  "exchange bet settled": "Exchange Bet Settled",
  exchange_rules: "Exchange Rules",
  "exchange-rules": "Exchange Rules",
  exchangebalance: "Exchange Balance",
  exchangeexposure: "Exchange Exposure",
  excluded: "Excluded",
  expired_bonus_tab: "Expired",
  expires: "Expires",
  expiry_date: "Expiry Date",
  expiry_date_error: "Please select a future date",
  exchange_yourself: "Exchange yourself!",
  failed_to_copy_password: "Failed to copy password",
  failed_to_copy_username: "Failed to copy username",
  failed_to_copy_text: "Failed to copy text",
  favouritegames: "Favourite Games",
  fee: "Fee",
  fee_type: "Fee Type",
  fees_info: "You will receive",
  filter: "Filter",
  find_your_utr: "Find Your UTR",
  footer_copyright: "© {year} SKY365. All rights reserved.",
  footer_disclaimer: "Disclaimer",
  footer_privacy_policy: "Privacy policy",
  footerpara2:
    "Sky365 is owned and operated by PrimeDigital Global Ltd. registration number: 15823, registered address: Hamchako, Autonomous island of Anjouan, Mutsamudu, Comoros 0000. Contact us",
  footerpara3:
    "Sky365 is licensed and regulated by the Government of the Autonomous Island of Anjouan, Union of Comoros and operates under License No. ALSI-202502010-FI1 .",
  forgot_password: "Forgot Password",
  forgot_password_label: "Set the new password",
  forgot_password_link: "Forgot Password?",
  free_spin: "Free Spin",
  freespin_bonus_step: "FS Rounds Used",
  full_name: "Full Name",
  game: "Game",
  game_added_favourite_list: "The game added to your favorite list",
  game_name: "Game Name",
  game_removed_favourite_list: "The game removed from your favorite list",
  games: "Games",
  general_payment_help: "General Payment Help",
  general_payment_help_step1: "Transfer ₹{amount} to the given account.",
  general_payment_help_step2: "Choose IMPS for faster processing.",
  general_payment_help_step3: "Enter your Ref. No / Trans. ID / UTR.",
  general_payment_help_step4: "Deposit will reflect within 5 minutes.",
  GetApp: "Get App",
  glossary: "Glossary",
  half_lost: "Half Lost",
  half_win: "Half Win",
  help: "Help",
  hey_there: "Hey There!",
  hi_lbl: "Hi",
  history_select_status: "Select Status",
  hold: "Hold",
  i_agree_with_terms_and_conditions: "I agree with Terms & Conditions.",
  identification: "Identification",
  ifsc: "IFSC",
  img_extention: "Please select files of JPG, JPEG, or PNG format",
  img_size: "File max limit is 5MB.",
  inbox: "Inbox",
  included: "Included",
  info: "ⓘ info",
  inprogress: "Inprogress",
  invalid_reference_number_for_type: "Invalid reference number for {type}",
  is_biomatrics: "Biometrics",
  joinNow: "Join Now",
  "kyc-policy": "KYC Policy",
  league_name: "League Name",
  liability: "Liability",
  login: "LOGIN",
  login_again: "Login Again",
  logout: "Logout",
  logout_confirmation: "Are you sure you want to logout?",
  lost: "Lost",
  max: "Max ₹",
  max_text: "Max",
  menu: "Menu",
  message_delete_notify: "The message was deleted successfully.",
  min: "Min ₹",
  min_text: "Min",
  minimumodds: "Minimum odds",
  mobile: "Mobile",
  mobile_email_verification: "03. Mobile Number or Email Verification",
  mobile_error: "Please enter your mobile number.",
  mobile_number: "Mobile Number",
  mobile_validation_error: "Please enter a valid mobile number",
  mobile_verified: "Mobile Verified Successfully.",
  month_deposit: "Monthly Deposit Limit",
  monthly_deposit_limit_placeholder: "Enter Monthly Deposit Limit",
  monthlydepositlimitnegativeamountvalidation:
    "Please enter a positive amount of monthly deposit limit.",
  monthlydepositlimitnotes:
    "Your new monthly deposit limit of ₹{0} will become effective in {1}h.",
  needhelp: "Need Help?",
  new: "New",
  new_password: "New Password",
  new_password_not_match:
    "The entered new password and confirm password do not match.",
  next: "Next",
  no: "no",
  no_active_bonus: "No Active Bonus",
  no_balance_adjustment: "No Balance Adjustment",
  no_bank_details: "No Banking Details Found",
  no_bonus_details_available: "No bonus details available.",
  no_cancelled_bonus: "No Cancelled Bonus",
  no_casino_history: "No Casino History",
  no_consumed_bonus: "No Consumed Bonus",
  no_data_found: "No Data Found",
  no_deposit_history: "No Deposit History",
  no_exchange_history: "No Exchange History",
  no_expired_bonus: "No Expired Bonus",
  no_games_found: "No Games Found",
  no_records_found: "No Records Found",
  no_sports_history: "No Sports History",
  no_wallet_history: "No Wallet History",
  no_withdraw_history: "No Withdraw History",
  not_accepted: "Not Accepted",
  odds: "Odds",
  ok_btn: "Ok",
  ok_response_profile_request_submitted: "Profile has been updated successfully",
  ok_response_request_performed_successfully: "Your request has been performed successfully.",
  okay: "Okay!",
  onclick_reset_password_label: "Wish an easier login? Set a new password.",
  oneclick: "One Click",
  only_character_allows: "Please enter alphabets only.",
  open: "Open",
  opt_in: "Opt In",
  others: "Others",
  over_eighteen_years_old: "I'm over 18 years old",
  page_not_found: "Page not found.",
  "pan card": "Pan Card",
  partialrefund: "Partial Refund",
  passport: "Passport",
  password: "Password",
  password_copied: "Password copied successfully",
  password_invalid: "Password is invalid",
  password_changed: "Password Changed",
  pay_via: "Pay Via",
  payment: "Payment",
  "payment-methods": "Payment Methods",
  payout: "Payout",
  pending: "Pending",
  phone: "Phone",
  placeholder_account_number: "Enter Account Number",
  placeholder_beneficiary_name: "Enter Beneficiary Name",
  placeholder_branch_name: "Enter Branch Name",
  placeholder_ifsc: "Enter IFSC / SWIFT",
  player: "Player",
  please_confirm_this_below_instructions:
    "Please confirm this below instructions.",
  please_enter_a_valid_number: "Please enter a valid number",
  please_enter_password: "Please Enter the Password to Verify!",
  please_setup_biomatrics:
    "Please setup biometrics (Face ID or Fingerprint) on your device in order to be able to activate them on Sky365 App",
  potentialwin: "Potential Win",
  privacy_policy: "Privacy Policy",
  "privacy-policy": "Privacy Policy",
  proceed: "Proceed",
  processed_date: "Processed date",
  processing: "Processing",
  profile: "Profile",
  profile_updated_successfully: "Profile updated successfully",
  promotion: "Promotions",
  proof_approval: "01. ID Proof Verification",
  provider_and_games: "Provider & Games",
  popup_blocker_redirect: "Please enable pop-ups and allow redirects to proceed.",
  read_all: "Mark all as Read",
  realmoney: "Main Wallet Balance",
  receive_cash_or_bonuses: "Want to receive cash and other bonuses?",
  recent_played: "Recent Played",
  ref_tran_utr: "Ref. No. / Trans. ID / UTR",
  reference_id: "Reference ID",
  reference_number: "Reference Number",
  refid_copy_failed: "Failed to copy reference ID",
  refid_note: "Please check this image to insert the correct Ref ID / UTR",
  refid_success_copied: "Reference ID Copied Successfully",
  refund: "Refund",
  register: "Register",
  rejected: "Rejected",
  remainingturnover: "Remaining Turnover",
  remark: "Remark",
  remarks: "Remarks",
  remove: "Remove",
  remove_avatar: "Remove Avatar",
  REQUEST_FROM_BLOCKED_USER:
    "The payment method is currently not available. Please try a different one.",
  request_update_btn: "Request Update",
  reset_password: "Reset Password",
  "responsible-gaming": "Responsible Gaming",
  revert: "Revert",
  revert_deposit_request: "Revert Deposit Request",
  reverted: "Reverted",
  round_id: "Round Id",
  rules: "Rules",
  reCAPTCHA_message: "Please verify you are not a robot.",
  saveasimage: "Save as Image",
  scan_qr_to_pay: "To make your payment please scan the QR code above",
  searchgame: "Search Game",
  searchtransactionid: "Search transaction ID",
  select: "Select",
  select_account_to_pay: "Select Account to Pay",
  select_btn: "select",
  select_category_lbl: "Select Category",
  select_crypto_currency: "please select crypto currency",
  select_date: "Select a date period",
  select_userbank: "Please select bank account",
  select_your_avatar: "Select Your Avatar",
  self_exclusion: "Self Exclusion",
  self_exclusion_policy_page: "Self Exclusion Policy",
  "self-exclusion-policy": "Self-Exclusion Policy",
  selfexcludeconfirmationlabel1:
    "Are you sure you want to self-exclude from your Sky365 account?",
  selfexcludeconfirmationlabel2:
    "The account will be closed permanently after confirmation.",
  selfexclusionlabel: "I want to Self Exclude my account",
  selfexclusionnotes:
    "By self-excluding from your Sky365 account, you won't be able to sign in or reactivate your account at any point in time. Self-Exclusion means that your account will be permanently closed. You agree not to open a new account with Sky365, and Sky365 will do everything possible to identify and close any new accounts you may illegally create. All communications between Sky365 and you will also be terminated permanently.",
  selfexclusionsuccesslabel:
    "Your Sky365 account is permanently Self Excluded.",
  send: "Send",
  send_details_on_email_or_phone: "Send Details on Email or Phone",
  session_error_model: "Session is expired! Please login again.",
  signup: "Sign up",
  site_title: "Sky365 - Sports Betting, Online Gaming",
  SMS: "SMS",
  sports: "Sports",
  "sports bet placed": "Sports Bet Placed",
  "sports bet resettled": "Sports Bet Resettled",
  "sports bet settled": "Sports Bet Settled",
  sports_bet: "Sports Bet",
  sportsbook: "Sportsbook",
  sportsbook_rules: "Sportsbook Rules",
  "sportsbook-rules": "Sportsbook Rules",
  sportsIndia: "Sports India",
  sql_error_account_closed:
    "Your account is closed. Please contact customer support for further assistance.",
  sql_error_account_not_found:
    "Sorry, we could not find any account in the system with the details provided.",
  sql_error_account_selfexclude:
    "This Account is closed. Contact Customer Support.",
  sql_error_add_future_expire_date: "Please add future expiry date of document",
  sql_error_adjustment_already_exists: "Manual adjusment already exists.",
  sql_error_amount_after_fee_should_not_Fifty:
    "Amount after fee deduction shouldn't be less than fifty. Please provide a valid amount.",
  sql_error_amount_after_fee_should_not_ten:
    "Amount after fee deduction shouldn't be less than ten. Please provide a valid amount.",
  sql_error_amount_after_fee_should_not_zero:
    "Amount after fee deduction cannot be zero. Please provide a valid amount.",
  sql_error_amount_maximum:
    "Provided amount is greater than maximum amount for selected bank",
  sql_error_amount_minimum:
    "Provided amount is less than minimum amount for selected bank",
  sql_error_amount_should_between_min_max:
    "Amount should be between the specified minimum and maximum limits.",
  sql_error_amount_should_not_zero: "Withdrawal limit is 10 to 30000",
  sql_error_bank_exists_for_user:
    "The bank account already exists in the system. Please insert new one or contact customer support.",
  sql_error_bank_id_invalid: "BankId is invalid",
  sql_error_birthdate_not_found: "Please enter valid birth date",
  sql_error_deposit_already_reverted:
    "This transaction has already been reverted. You cannot revert it again.",
  sql_error_deposit_amount_large_deposit_limit:
    "The intended amount exceeds the daily deposit limit set on your account. Please try again with a smaller amount",
  sql_error_deposit_amount_large_monthly_deposit_limit:
    "The intended amount exceeds the monthly deposit limit set on your account. Please try again with a smaller amount.",
  sql_error_deposit_amount_large_weekly_deposit_limit:
    "The intended amount exceeds the weekly deposit limit set on your account. Please try again with a smaller amount.",
  sql_error_deposit_final_status_revert_not_allowed:
    "This transaction has already reached its final status, so a revert is no longer possible.",
  sql_error_deposit_further_status_revert_not_allowed:
    "This request is being processed already. Revert not possible anymore.",
  sql_error_deposit_not_allowed:
    "Deposit Type is Not Allowed.Please try with other one.",
  sql_error_deposit_update_request_not_allowed:
    "Deposit transaction update request is not allowed for this transaction.",
  sql_error_document_exist_for_user:
    "Document details already exist in the system. Insert new details or contact customer support.",
  sql_error_email_already_exists:
    "This email id is already registered, please try with another email id.",
  sql_error_email_not_found: "Email not found",
  sql_error_email_not_verified: "Your email Is not verified yet",
  sql_error_exchange_balance_negative:
    "This Withdrawal cannot be performed now due to negative balance and/or change of settlement impacting your wallet(s) funds. Kindly try again after some time.",
  sql_error_feetype_disabled:
    "Withdrawals are currently unavailable, please try again after some time",
  sql_error_for_user_bank_data_exists:
    "The bank document you are currently editing has been approved by the admin since you started. Further edits are not allowed.",
  sql_error_for_user_proof_data_exists:
    "The proof document you are currently editing has been approved by the admin since you started. Further edits are not allowed.",
  sql_error_freespinbonus_exists:
    "A bonus has already been scheduled within the specified time frame for the same game.",
  sql_error_invalid_user_bank_id: "User bank id is invalid",
  sql_error_invalid_wallet_address: "User wallet address is invalid",
  sql_error_last_deposit_in_process: "Your deposit is in process",
  sql_error_last_withdraw_in_process:
    "You last withdraw is either pending or processing.",
  sql_error_mobile_already_exists:
    "This mobile number is already registered, please try with another mobile number.",
  sql_error_mobile_not_found: "Mobile number inserted does not exist.",
  sql_error_mobileno_not_verified: "Your mobile number is not verified yet",
  sql_error_monthly_is_less_than_daily_amount:
    "Your monthly deposit amount must be greater than daily deposit amount",
  sql_error_monthly_is_less_than_weekly_amount:
    "Your monthly deposit amount must be greater than weekly deposit amount",
  sql_error_multiple_login:
    "You have been logged off because you have logged on at another location.",
  sql_error_new_password_same_as_old_2:
    "Your new password must be different from your current password!",
  sql_error_otp_expire: "The code inserted is expired,Resend a new one in:",
  sql_error_otp_incorrect:
    "The code inserted is wrong, please insert it again!",
  sql_error_password_invalid: "Username or password is invalid.",
  sql_error_provide_password_confirmpassword_3:
    "'New Password' and 'Confirm Password' do not match",
  sql_error_provide_valid_old_password_1: "Please enter valid current password",
  sql_error_record_not_found: "Record not found",
  sql_error_referencenumber_exists:
    "The ReferenceID/UTR was already used. Please upload a new one.",
  sql_error_user_deactivated: "The account is closed",
  sql_error_user_inactivated:
    "User is inactive please contact to administration department",
  sql_error_user_not_found: "Username does not exist, Please try again",
  sql_error_username_already_exists:
    "Username already exists. Please try with different username",
  sql_error_username_not_exists: "Username or password is invalid.",
  sql_error_wallet_address_already_exists:
    "The wallet address already exists in the system. Please insert new one or contact customer support.",
  sql_error_weekly_is_less_than_daily_amount:
    "Your weekly deposit amount must be greater than daily deposit amount",
  sql_error_withdraw_amount_less_than_balance:
    "Withdraw request amount is greater than available balance",
  sql_error_withdraw_further_status_revert_not_allowed:
    "Your request is being processed by admin. Further revert is not allowed.",
  sql_error_withdraw_revert_not_allowed:
    "Revert not allowed. Kindly contact to admin.",
  sql_error_withdraw_type_not_allowed:
    "Selected WithdrawType is not allowed. Please Choose Another.",
  sql_error_withdraw_update_request_not_allowed:
    "Withdraw transaction update request is not allowed for this transaction.",
  sql_error_withdrawtype_disabled:
    "Withdrawals are currently unavailable, please try again after some time.",
  sql_previous_password_security:
    "To ensure security, please choose a new password different from your previous one.",
  stake: "Stake",
  start: "Start",
  start_deposit: "Start Deposit",
  start_journey: "Start Journey with us",
  startbalance: "Start Balance",
  status: "Status",
  submit: "Submit",
  success_copied: "Copied Successfully",
  sure_you_want_delete_this_message:
    "Are you sure you want to delete this message?",
  swift_ifsc: "SWIFT/IFSC",
  sql_error_amount_after_fee_should_not_hundred: "Amount after fee deduction shouldn't be less than hundred. Please provide a valid amount.",
  take_a_break: "Take A Break",
  takeabreakconfirmationlabel: "Are you sure you want to Take a Break for {0}?",
  takeabreaknotes:
    "By Taking a break from your Sky365 account, you won't be able to sign in or reactivate your account during the requested period. Taking a break means that your account will not be active for a certain period of time. During a take a break period, all communications between Sky365 and you will also be suspended.",
  takeabreaksuccesslabel: "Your Sky356 account is temporary disabled until:",
  "terms-and-conditions": "Terms And Conditions",
  time_period: "Select a Time Period",
  total_bonus_amount: "Bonus Amount Won",
  totalodds: "Total Odds",
  "tournament reward": "Tournament Reward",
  transaction: "Transaction",
  transaction_update_lbl: "Transaction Update",
  transactionid: "Transaction ID",
  transactions: "Transactions",
  transferred_by: "Transferred By",
  transid_success_copied: "Transaction ID Copied Successfully",
  trending_games: "Trending Games",
  try_now: "Try Now",
  TandC_message: "Please read and accept the terms and conditions.",
  undo_request: "Undo Request",
  update_transaction_text1: "Your request is under analysis by our team!",
  update_transaction_text2:
    "Once finished, you'll be notified with our response.",
  update_transaction_text3: "Thank you for your patience!",
  upiid: "UPI Id",
  upload_avatar: "Upload Avatar",
  upload_bank_document: "Upload Bank Document",
  uploaded_bank_document: "Uploaded Bank Document",
  upload_document_back: "Back Image",
  upload_document_front: "Front Image",
  upload_document_lbl: "Upload Document",
  upload_document_text1:
    "Can you upload the payment proof here or share any additional concerns?",
  upload_document_text2:
    "*These fields are optional, but sharing more details will help us support you faster.",
  upload_file_document: "Upload File Document",
  upload_image_lbl: "JPG, JPEG or PNG format accepted.",
  upload_image_lbl_size: "Max file size 5MB.",
  upload_without_attachment_btn: "Submit Request",
  username_copied: "Username copied successfully",
  uptp_3: "up to 3",
  username: "Username",
  valid_beneficiary_name: "Please enter a valid beneficiary name",
  valid_branch_name: "Please enter a valid branch name",
  valid_email: "Please enter a valid email address",
  valid_enter_amount: "Please enter amount",
  valid_ifsc_code: "Please enter a valid IFSC/SWIFT code",
  valid_password_must_contain:
    "Password should be alphanumeric and must contain special characters too. (e.g. @_-*)",
  validate_documenttype: "Please enter valid @documenttype details.",
  verfiy_your_number: "Verify your Number",
  verification: "Verification",
  verified: "Verified",
  verify_all_email_preferences:
    "To enable All you need to insert and verify your email!",
  verify_btn: "Verify",
  verify_details: "Please verify your details!",
  verify_email_preferences:
    "To enable email contact you need to insert and verify your email!",
  verify_mobile_preferences:
    "To enable SMS you need to insert and verify your mobile number!",
  verify_otp: "Verify OTP",
  verify_your_email: "Verify your Email",
  voided: "Voided",
  valid_username: "Please enter valid username",
  wallet: "Wallet",
  wallet_address: "Wallet Address",
  wallet_id: "Wallet ID",
  wallethistory: "Wallet History",
  walletid_copy_failed: "Failed to copy wallet ID",
  walletid_success_copied: "Wallet ID Copied Successfully",
  weekly_deposit: "Weekly Deposit Limit",
  weekly_deposit_limit_placeholder: "Enter Weekly Deposit Limit",
  weeklydepositlimitnegativeamountvalidation:
    "Please enter a positive amount of weekly deposit limit.",
  weeklydepositlimitnotes:
    "Your new weekly deposit limit of ₹{0} will become effective in {1}h.",
  weeklylimit_biggerthan_weekly:
    "Weekly limit cannot be bigger than monthly limit.",
  welcome: "Welcome!",
  welcome_back: "Welcome Back",
  whatsapp: "WhatsApp",
  whatsapp_reset_password_label: "Set new password",
  Whatsapp_Telegram: "Whatsapp / Telegram",
  Widthdrawable_Bal: "Withdrawable Balance :",
  win: "Win",
  winning_boost: "Winning Boost",
  winning_boost_days: "Winning Boost Days",
  winning_boost_dates: "Winning Boost Dates",
  winning_boost_play_time: "Winning Boost Play Time",
  withdraw: "Withdraw",
  "withdraw pending": "Withdraw Pending",
  "withdraw processed": "Withdraw Processed",
  "withdraw rejected": "Withdraw Rejected",
  "withdraw reverted": "Withdraw Reverted",
  withdraw_approved_notification: "Your amount withdraw was approved!",
  withdraw_approved_utr_notification:
    "Your amount withdraw was approved. the transaction UTR is utrnumber!",
  withdraw_get: "Amount You’ll get:",
  withdraw_mobile_verify_note:
    "To make a Crypto Withdraw your mobile number must be verified first.",
  withdraw_note:
    "In order to request a withdrawal, you must complete the 3 steps below",
  withdraw_process: "Your withdrawal is under process!",
  withdraw_rejected_notification: "Your amount withdraw was not approved!",
  withdraw_revert_confirmation_label:
    "Are you sure you want to revert this withdrawal request?",
  withdraw_revert_confirmation_lable:
    "Are you sure to revert this withdrawal back to your Sky365 account?",
  withdraw_status: "Check withdrawal status",
  withdraw_success_reverted:
    "Your withdrawal was reverted. You can request a new withdrawal now.",
  withdraw_top_lbl: "Choose your withdraw method",
  withdraw_transaction_update_sent:
    "Withdraw transaction update request has been sent.",
  withdraw_type: "Withdraw Type",
  withdrawable: "Withdraw Balance",
  withdrawal_amount: "Withdrawal Amount",
  withdrawal_fee: "Withdrawal Fee",
  withdrawProcessingDetails:
    "Only one withdrawal is allowed at a time. Your last withdrawal is currently being processed. A new withdrawal request will be allowed shortly.",
  write_your_additiona_concerns: "Write Your Additional Concerns",
  yes: "yes",
  you_cannot_apply_this_promocode: "You cannot apply this promocode.",
  your_market_your_move: "Your Market. Your Move.",
};

export default en;